import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useIntl } from "react-intl";
import PdfViewer from "../../components/PdfViewer";

const getPdfUrl = locale =>
  ({
    [locale]:
      "https://buscar.terras.app/app/files/termos-de-uso-buscar-04-09-2020.pdf",
    'en-US': 'https://buscar.terras.app/app/files/buscar_terms-of-use_09-04-2020.pdf'
  }[locale]);

const TermsOfUse = () => {
  const { formatMessage, locale } = useIntl();
  const [pdfUrl, setPdfUrl] = useState(getPdfUrl(locale));

  useEffect(() => {
    setPdfUrl(getPdfUrl(locale));
  }, [locale]);

  return (
    <>
      <h1>{formatMessage({ id: "termos-uso" })}</h1>

      <div className="content-box terms-of-use">
        <PdfViewer url={pdfUrl} title={formatMessage({ id: "termos-uso" })} />
      </div>
    </>
  );
};

export default TermsOfUse;
